<template >
  <div :key="'composition-api-computed'">
    <pre><code class="javascript" data-trim data-noescape data-line-numbers="1-99" v-html="exampleText"></code></pre>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exampleText: `// simplified pseudo code
function computed(getter) {
  const ref = {
    value: null
  }
  watch(() => {
    ref.value = getter()
  })
  return ref
}`
    };
  }
};
</script>